// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div class="box">

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#loan-parameters" data-toggle="tab">
          <span><i ng-show="\$ctrl.paramsForm.\$invalid" class="icon icon-warning-sign"></i>Loan parameters</span>
        </a>
      </li>
      <li ng-if="\$ctrl.showRenewedLoan()">
        <a data-target="#loan-waive" data-toggle="tab" id="waive-link">
          <span><i ng-show="\$ctrl.waiveForm.\$invalid" class="icon icon-warning-sign"></i>Renewed loan</span>
        </a>
      </li>
      <li>
        <a data-target="#loan-override" data-toggle="tab" id="override-link">
          <span title="{{\$ctrl.feesAutoUpdated}}">
            <i ng-show="\$ctrl.overrideForm.\$invalid" class="icon icon-warning-sign"></i>
            <i ng-show="!\$ctrl.overrideForm.\$invalid && \$ctrl.feesAutoUpdated" class="icon icon-info-sign icon-orange"></i>
            Loan charges override
          </span>
        </a>
      </li>
      <li ng-if="\$ctrl.showConsolidatedLoans()">
        <a data-target="#consolidated-form" data-toggle="tab" id="consolidated-loans">
          <span><i ng-show="\$ctrl.consolidationForm.\$invalid" class="icon icon-warning-sign"></i>Consolidated loans</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="tab-content" ng-form="\$ctrl.parentForm">
    <div class="tab-pane active" id="loan-parameters">
      <customer-loan-create-parameters
        form-param="\$ctrl.paramsForm"
        customer-id="\$ctrl.customerId"
        loan="\$ctrl.loan"
        loan-product="\$ctrl.loan.loanType"
        group-loan="false">
      </customer-loan-create-parameters>
    </div>
    <!-- rendered once the saved waive is loaded: loan-pre-terminate restores the waive it is given when it starts -->
    <div class="tab-pane" id="loan-waive" ng-if="\$ctrl.showRenewedLoan()">
      <loan-pre-terminate
        form-name="\$ctrl.waiveForm"
        max-values="\$ctrl.loan.existingAmortizationSchedule.totalBalance"
        waive-request="\$ctrl.loan.waiveRequest"
        payment-request="\$ctrl.empty"
        loan="\$ctrl.loan.sourceLoan">
      </loan-pre-terminate>
    </div>
    <div class="tab-pane" id="loan-override">
      <customer-loan-charges-override
        form-name="\$ctrl.overrideForm"
        loan="\$ctrl.loan"
        loan-product="\$ctrl.loan.loanType"
        on-updated="\$ctrl.onFeesAutoUpdated"
      >
      </customer-loan-charges-override>
    </div>

    <div ng-class="{'tab-pane': !\$ctrl.singlePage}" id="consolidated-form" ng-if="\$ctrl.showConsolidatedLoans()">
      <ng-form name="\$ctrl.consolidationForm">
        <loan-consolidation loan="\$ctrl.loan">
        </loan-consolidation>
      </ng-form>
    </div>

    <div class="summary-actions">
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button type="submit" class="btn btn-primary" ng-click="\$ctrl.updateParamsAndCharges()"
              ng-disabled="\$ctrl.parentForm.\$invalid || \$ctrl.isRenewedLoanPending()">
        Save
      </button>
    </div>

  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/params/customer-loans-edit-params-and-charges.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;